import React from 'react';
import { useSelector } from 'react-redux';
import { Flex, Box } from 'roo-ui/components';
import { getMastercardSessionData } from 'store/checkout/checkoutSelectors';
import { MONTHS } from 'lib/enums/checkout';

const LABEL_WIDTH = 200;

const MastercardDetails = () => {
  const creditCard = useSelector(getMastercardSessionData);
  const cardLastFourDigits = (creditCard.cardNumber || '').substr(12, 16);
  const month = MONTHS[Number(creditCard.expiryMonth) - 1];
  const year = `20${creditCard.expiryYear}`; // should be good for 80 years or so.

  return (
    <Box>
      <Flex pb={3} flexDirection={['column', 'row']}>
        <Box width={LABEL_WIDTH}>Card details</Box>
        <Box fontWeight="bold" data-testid="card-type-and-number">
          {creditCard.cardType} ending with {cardLastFourDigits}
        </Box>
      </Flex>
      <Flex pb={3} flexDirection={['column', 'row']}>
        <Box width={LABEL_WIDTH}>Name on card</Box>
        <Box fontWeight="bold" data-testid="name-on-card">
          {creditCard.nameOnCard}
        </Box>
      </Flex>
      <Flex flexDirection={['column', 'row']}>
        <Box width={LABEL_WIDTH}>Expiry date</Box>
        <Box fontWeight="bold" data-testid="card-expiry">
          {month} {year}
        </Box>
      </Flex>
    </Box>
  );
};

export default MastercardDetails;
